<div
  class="stack"
  role="status"
  aria-live="polite"
  [plWarnBeforeUnload]="building()"
>
  @for (job of visibleJobs(); track job.id) {
    <div
      class="snackbar"
      [attr.data-testid]="'lesson-generation-' + job.status"
    >
      <div class="text">
        @switch (job.status) {
          @case ('processing') {
            <div class="title">
              {{
                'lesson-generation-snackbar.buildingTitle'
                  | translate: {fileName: job.source.fileName}
              }}
            </div>
            <div class="line">
              {{ 'lesson-generation-snackbar.buildingLine' | translate }}
            </div>
          }
          @case ('complete') {
            <div class="title ready">
              <span class="ready-icon" aria-hidden="true">
                <mat-icon svgIcon="check" />
              </span>
              <span class="name">{{ job.lesson?.title }}</span>
              <span class="visually-hidden">{{
                'lesson-generation-snackbar.readyTitle'
                  | translate: {title: job.lesson?.title}
              }}</span>
            </div>
            <div class="line">
              <button
                type="button"
                class="view-lesson"
                data-testid="lesson-generation-view"
                (click)="viewLesson(job.id)"
              >
                {{ 'lesson-generation-snackbar.viewLesson' | translate }}
              </button>
            </div>
          }
          @case ('failed') {
            <div class="title">
              {{
                'lesson-generation-snackbar.failedTitle'
                  | translate: {fileName: job.source.fileName}
              }}
            </div>
            <div class="line">
              {{ 'lesson-generation-snackbar.failedLine' | translate }}
            </div>
          }
        }
      </div>
      @if (job.status === 'processing') {
        <button
          mat-icon-button
          class="close"
          data-testid="lesson-generation-hide"
          [matTooltip]="'lesson-generation-snackbar.hideTooltip' | translate"
          [attr.aria-label]="
            'lesson-generation-snackbar.hideTooltip' | translate
          "
          (click)="hide(job.id)"
        >
          <mat-icon svgIcon="close" />
        </button>
        <mat-progress-bar
          class="progress"
          mode="determinate"
          [value]="job.progress"
          [attr.aria-label]="
            'lesson-generation-snackbar.progressA11y'
              | translate: {fileName: job.source.fileName}
          "
        />
      } @else {
        <button
          mat-icon-button
          class="close"
          data-testid="lesson-generation-close"
          [attr.aria-label]="'common.close' | translate"
          (click)="dismiss(job.id)"
        >
          <mat-icon svgIcon="close" />
        </button>
      }
    </div>
  }
</div>
